import React from "react";

import { Badge } from "../../../common/components/core";
import { InvoiceStatus } from "../../../types/invoice";
import { UserRole } from "../../../types/userCurrent";
import { hasInvoiceAction } from "../../../utils/invoice";
import { isUserFinanceDepartment, isUserPO } from "../../../utils/role";

type InvoiceStatusBadgeProps = {
    roles: UserRole[];
    status: InvoiceStatus;
};

const InvoiceStatusBadge = ({
    roles,
    status,
}: InvoiceStatusBadgeProps): JSX.Element => {
    switch (true) {
        case hasInvoiceAction(roles, status):
            return <Badge type="danger">Action Required</Badge>;
        case status === InvoiceStatus.CONTRACTOR_DISCARDED:
            return <Badge type="discarded">Discarded</Badge>;
        case status === InvoiceStatus.FINANCE_APPROVED:
            return <Badge type="success">Approved</Badge>;
        case status === InvoiceStatus.PO_REJECTED && isUserPO(roles):
        case status === InvoiceStatus.FINANCE_REJECTED &&
            isUserFinanceDepartment(roles):
            return <Badge type="danger">Rejected</Badge>;
        default:
            return <Badge type="info">Pending</Badge>;
    }
};

export default InvoiceStatusBadge;
